// Copyright (c) 2018 Deere & Company

export const getAnswerValue = question => {

    let answerValue;

    answerValue = '';

    if (question.type === 'O') {

        const option = question.options.find(item => item.key === question.answer);

        if (option) {

            answerValue = option.value;

        }

    }

    if (question.type === 'S') {

        answerValue = question.answer;

    }

    return answerValue;

};



// WEBPACK FOOTER //
// ./src/part-requests/request-details/services/get-answer-value.js